import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-35a7287b")

_pushScopeId("data-v-35a7287b")
const _hoisted_1 = { class: "relative bg-white rounded-xl mb-4" }
const _hoisted_2 = { class: "pb-4 mb-4 p-4 border-b" }
const _hoisted_3 = {
  key: 0,
  class: "w-full mb-2 px-4"
}
const _hoisted_4 = { class: "px-4 pb-2" }
const _hoisted_5 = { class: "grid grid-cols-2 gap-x-6 gap-y-2 mb-4" }
const _hoisted_6 = { class: "mt-1.5" }
const _hoisted_7 = { class: "mt-1.5" }
const _hoisted_8 = { class: "mt-1.5" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "mt-1.5" }
const _hoisted_11 = { class: "mt-1.5" }
const _hoisted_12 = { class: "grid grid-cols-1 mb-4" }
const _hoisted_13 = { class: "py-3 flex flex-row gap-x-5" }
const _hoisted_14 = {
  key: 1,
  class: "grid grid-cols-2 gap-y-4 gap-x-6 mb-4"
}
const _hoisted_15 = { class: "mt-1.5" }
const _hoisted_16 = { class: "mt-1.5" }
const _hoisted_17 = {
  key: 2,
  class: "grid grid-cols-2 gap-y-4 gap-x-6 mb-4"
}
const _hoisted_18 = { class: "mt-1.5" }
const _hoisted_19 = { class: "mt-1.5" }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "mt-1.5" }
const _hoisted_22 = { class: "mt-1.5" }
const _hoisted_23 = { class: "grid grid-cols-2 gap-y-4 gap-x-6 mb-4" }
const _hoisted_24 = { class: "mt-1.5" }
const _hoisted_25 = { class: "mt-1.5" }
const _hoisted_26 = { class: "grid grid-cols-2 gap-y-4 gap-x-6 mb-4" }
const _hoisted_27 = { class: "mt-1.5" }
const _hoisted_28 = { class: "mt-1.5" }
const _hoisted_29 = { class: "grid grid-cols-2 gap-y-4 gap-x-6" }
const _hoisted_30 = { class: "mt-1.5" }
const _hoisted_31 = { class: "text-red-lp-100 text-12px xxl:text-14px" }
const _hoisted_32 = { class: "mt-1.5" }
const _hoisted_33 = { class: "text-red-lp-100 text-12px xxl:text-14px" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Title = _resolveComponent("Title")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_SelectHours = _resolveComponent("SelectHours")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Title, { label: "Kriteria konfigurasi pesan" })
    ]),
    (_ctx.isFormTypeEdit)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode(_component_DataWrapper, { label: "ID Konfig" }, {
            default: _withId(() => [
              _createVNode(_component_LpInput, {
                disabled: true,
                "model-value": _ctx.form.configId,
                disableBackground: ""
              }, null, 8, ["model-value"])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_DataWrapper, { label: "Judul Pesan" }, {
          default: _withId(() => [
            _createVNode(_component_LpInput, {
              modelValue: _ctx.form.messageTitle,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.messageTitle = $event)),
              disabled: _ctx.isFormTypeEdit,
              placeholder: "Masukkan judul pesan",
              maxLength: "100",
              disableBackground: ""
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_DataWrapper, {
          label: "Tipe Pesan",
          asterisk: true
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_CustomDropdown, {
                isExpand: _ctx.messageTypeSelect,
                "onUpdate:isExpand": _cache[2] || (_cache[2] = ($event: any) => (_ctx.messageTypeSelect = $event)),
                options: _ctx.messageTypeOptions,
                onSelect: _ctx.onSelectMessageType,
                placeholder: "Pilih tipe pesan",
                class: "w-full",
                isCustomWidth: "",
                selectedItem: _ctx.form.messageType,
                isDisabled: _ctx.isFormTypeEdit,
                disableBackground: _ctx.isFormTypeEdit
              }, null, 8, ["isExpand", "options", "onSelect", "selectedItem", "isDisabled", "disableBackground"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_DataWrapper, {
          label: "Tipe Layanan",
          asterisk: true
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_CustomDropdown, {
                isExpand: _ctx.serviceTypeSelect,
                "onUpdate:isExpand": _cache[3] || (_cache[3] = ($event: any) => (_ctx.serviceTypeSelect = $event)),
                options: _ctx.packageTypeOptions,
                onSelect: _ctx.onSelectServiceType,
                placeholder: "Pilih tipe layanan",
                class: "w-full",
                isCustomWidth: "",
                selectedItem: _ctx.form.packageType
              }, null, 8, ["isExpand", "options", "onSelect", "selectedItem"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_DataWrapper, {
          label: "Status Berita",
          asterisk: true
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_CustomDropdown, {
                isExpand: _ctx.eventStatusSelect,
                "onUpdate:isExpand": _cache[4] || (_cache[4] = ($event: any) => (_ctx.eventStatusSelect = $event)),
                options: _ctx.eventStatusOptions,
                onSelect: _ctx.onChangeEventStatus,
                placeholder: "Pilih status berita",
                class: "w-full",
                isCustomWidth: "",
                selectedItem: _ctx.form.eventStatus
              }, null, 8, ["isExpand", "options", "onSelect", "selectedItem"])
            ])
          ]),
          _: 1
        }),
        (_ctx.form.isOverSla)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 0,
              label: "Hari over SLA lebih dari",
              asterisk: "",
              tooltipDescription: "Pesan akan dikirim sehari setelah melewati total hari over SLA yang telah diatur."
            }, {
              default: _withId(() => [
                _createVNode(_component_LpInput, {
                  modelValue: _ctx.form.msgConfCountSla,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.msgConfCountSla = $event)),
                  type: "number",
                  placeholder: "Masukan jumlah hari"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.form.isOverSla)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 1,
              label: "Waktu kirim pesan",
              asterisk: ""
            }, {
              default: _withId(() => [
                _createVNode(_component_SelectHours, {
                  modelValue: _ctx.form.msgConfCronHours,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.msgConfCronHours = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      (_ctx.displayReasonField)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            (_ctx.form.eventStatus != 'DEX')
              ? (_openBlock(), _createBlock("div", _hoisted_9))
              : _createCommentVNode("", true),
            _createVNode(_component_DataWrapper, {
              label: "Alasan dari status berita",
              asterisk: "",
              "custom-class": "text-gray-lp-300 mb-4"
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_10, [
                  _createVNode(_component_MultipleSelectSearch, {
                    ref: "reasonField",
                    "modal-title": "Cari atau pilih alasan status berita",
                    "option-name": "reason",
                    onFocus: _ctx.fetchReason,
                    options: _ctx.reasonData,
                    modelValue: _ctx.form.reasons,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.reasons = $event)),
                    keyName: "name",
                    keyValue: "value",
                    placeholder: "Pilih alasan status berita",
                    isLoading: _ctx.loadingReason,
                    "able-to-delete-in-modal": ""
                  }, null, 8, ["onFocus", "options", "modelValue", "isLoading"])
                ])
              ]),
              _: 1
            }),
            (_ctx.form.eventStatus === 'DEX')
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 1,
                  label: "Attempt DEX Ke",
                  asterisk: "",
                  "custom-class": "text-gray-lp-300 mb-4"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_LpInput, {
                      modelValue: _ctx.form.msgConfAttemptDex,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.msgConfAttemptDex = $event)),
                      format: _ctx.formatNumber,
                      placeholder: "Masukan attempt DEX"
                    }, null, 8, ["modelValue", "format"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(_component_DataWrapper, {
        label: "Jenis Pengiriman",
        asterisk: "",
        "custom-class": "text-gray-lp-300 mb-4"
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_MultipleSelectSearch, {
              ref: "productField",
              "modal-title": "Cari atau pilih jenis pengiriman",
              "option-name": "products",
              onFocus: _ctx.fetchProducts,
              onFilter: _ctx.filterProducts,
              options: _ctx.productOptions,
              modelValue: _ctx.form.product,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.product = $event)),
              keyName: "name",
              keyValue: "value",
              placeholder: "Cari atau pilih jenis pengiriman",
              isLoading: _ctx.loadingProduct,
              "able-to-delete-in-modal": ""
            }, null, 8, ["onFocus", "onFilter", "options", "modelValue", "isLoading"])
          ])
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_12, [
        _createVNode(_component_DataWrapper, {
          label: "STT Dibuat Untuk",
          asterisk: true
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_13, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.appliedToOptions, (option) => {
                return (_openBlock(), _createBlock("div", {
                  key: option.value,
                  class: "gap-x-2 flex flex-row  items-center lp-checkbox p-field-checkbox"
                }, [
                  _createVNode(_component_Checkbox, {
                    id: `checkbox-${option.value}`,
                    name: "applied-to-message",
                    value: option.value,
                    modelValue: _ctx.form.appliedTo,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.appliedTo = $event)),
                    onChange: ($event: any) => (_ctx.onCheckSTTCreatedFor(option.value))
                  }, null, 8, ["id", "value", "modelValue", "onChange"]),
                  _createVNode("label", {
                    class: "font-bold",
                    for: `checkbox-${option.value}`
                  }, _toDisplayString(option.name), 9, ["for"])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]),
      (_ctx.showSelectPOS)
        ? (_openBlock(), _createBlock("div", _hoisted_14, [
            _createVNode(_component_DataWrapper, {
              label: "Nama POS",
              asterisk: true
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_15, [
                  _createVNode(_component_MultipleSelectSearch, {
                    "modal-title": "POS Terpilih",
                    "option-name": "POS",
                    onFocus: _ctx.fetchPOS,
                    onFilter: _ctx.filterPOS,
                    options: _ctx.posOptions,
                    modelValue: _ctx.form.posPartners,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.posPartners = $event)),
                    keyName: "name",
                    keyValue: "value",
                    placeholder: "Pilih POS",
                    isLoading: _ctx.isLoadingPOS,
                    onChange: _ctx.onChangePOS,
                    "able-to-delete-in-modal": ""
                  }, null, 8, ["onFocus", "onFilter", "options", "modelValue", "isLoading", "onChange"])
                ])
              ]),
              _: 1
            }),
            (_ctx.isChooseAllPOS)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 0,
                  label: "Pengecualian POS",
                  optional: ""
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_16, [
                      _createVNode(_component_MultipleSelectSearch, {
                        "modal-title": "Pengecualian POS Terpilih",
                        "option-name": "POS",
                        onFocus: _ctx.fetchPOS,
                        onFilter: _ctx.filterPOS,
                        options: _ctx.posExcludeOptions,
                        modelValue: _ctx.form.posPartnersExclude,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.form.posPartnersExclude = $event)),
                        keyName: "name",
                        keyValue: "value",
                        placeholder: "Pilih POS",
                        isLoading: _ctx.isLoadingPOS,
                        "able-to-delete-in-modal": ""
                      }, null, 8, ["onFocus", "onFilter", "options", "modelValue", "isLoading"])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.showSelectClientBranch)
        ? (_openBlock(), _createBlock("div", _hoisted_17, [
            _createVNode(_component_DataWrapper, {
              label: "Nama Client Cabang",
              asterisk: true
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_18, [
                  _createVNode(_component_MultipleSelectSearch, {
                    "modal-title": "Client Cabang Terpilih",
                    "option-name": "Client Cabang",
                    onFocus: _ctx.fetchClientBranch,
                    onFilter: _ctx.filterClientBranch,
                    options: _ctx.clientBranchOptions,
                    modelValue: _ctx.form.clientBranches,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.form.clientBranches = $event)),
                    keyName: "name",
                    keyValue: "value",
                    placeholder: "Pilih Client Cabang",
                    isLoading: _ctx.isLoadingClientBranch,
                    onChange: _ctx.onChangeClientBranch,
                    "able-to-delete-in-modal": ""
                  }, null, 8, ["onFocus", "onFilter", "options", "modelValue", "isLoading", "onChange"])
                ])
              ]),
              _: 1
            }),
            (_ctx.isChooseAllClientBranch)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 0,
                  label: "Pengecualian Client Cabang",
                  optional: ""
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_19, [
                      _createVNode(_component_MultipleSelectSearch, {
                        "modal-title": "Pengecualian Client Cabang Terpilih",
                        "option-name": "Client Cabang",
                        onFocus: _ctx.fetchClientBranch,
                        onFilter: _ctx.filterClientBranch,
                        options: _ctx.clientBranchExcludeOptions,
                        modelValue: _ctx.form.clientBranchesExclude,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.form.clientBranchesExclude = $event)),
                        keyName: "name",
                        keyValue: "value",
                        placeholder: "Pilih Client Cabang",
                        isLoading: _ctx.isLoadingClientBranch,
                        "able-to-delete-in-modal": ""
                      }, null, 8, ["onFocus", "onFilter", "options", "modelValue", "isLoading"])
                    ])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock("div", _hoisted_20)),
            _createVNode(_component_DataWrapper, {
              label: "Nama Client Parent",
              asterisk: true
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_21, [
                  _createVNode(_component_MultipleSelectSearch, {
                    isDisabled: _ctx.form.clientBranches[0]?.value === 'All',
                    "modal-title": "Client Parent Terpilih",
                    "option-name": "Client Parent",
                    onFocus: _ctx.fetchClientParent,
                    onFilter: _ctx.filterClientParent,
                    options: _ctx.clientParentOptions,
                    modelValue: _ctx.form.clientParent,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.form.clientParent = $event)),
                    keyName: "name",
                    keyValue: "value",
                    placeholder: "Pilih Client Parent",
                    isLoading: _ctx.isLoadingClientParent,
                    onChange: _ctx.onChangeClientParent,
                    "able-to-delete-in-modal": ""
                  }, null, 8, ["isDisabled", "onFocus", "onFilter", "options", "modelValue", "isLoading", "onChange"])
                ])
              ]),
              _: 1
            }),
            (_ctx.isChooseAllClientBranch)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 2,
                  label: "Pengecualian Client Parent",
                  optional: ""
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_22, [
                      _createVNode(_component_MultipleSelectSearch, {
                        "modal-title": "Pengecualian Client Parent Terpilih",
                        "option-name": "Client Parent",
                        onFocus: _ctx.fetchClientParent,
                        onFilter: _ctx.filterClientParent,
                        options: _ctx.clientParentExcludeOptions,
                        modelValue: _ctx.form.clientParentExclude,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.form.clientParentExclude = $event)),
                        keyName: "name",
                        keyValue: "value",
                        placeholder: "Pilih Client Parent",
                        isLoading: _ctx.isLoadingClientParent,
                        "able-to-delete-in-modal": ""
                      }, null, 8, ["onFocus", "onFilter", "options", "modelValue", "isLoading"])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_23, [
        _createVNode(_component_DataWrapper, {
          label: "Kota Asal",
          asterisk: true
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_24, [
              _createVNode(_component_MultipleSelectSearch, {
                "modal-title": "Kota Asal Terpilih",
                "option-name": "kota",
                onFocus: _ctx.fetchCity,
                onFilter: _ctx.filterCity,
                options: _ctx.cityOptions,
                modelValue: _ctx.form.originCities,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.form.originCities = $event)),
                keyName: "name",
                keyValue: "value",
                placeholder: "Pilih kota",
                isLoading: _ctx.isLoadingCity,
                onChange: _ctx.onChangeOriginCity,
                "able-to-delete-in-modal": ""
              }, null, 8, ["onFocus", "onFilter", "options", "modelValue", "isLoading", "onChange"])
            ])
          ]),
          _: 1
        }),
        (_ctx.isChooseAllCityOrigin)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 0,
              label: "Pengecualian Kota Asal",
              optional: ""
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_25, [
                  _createVNode(_component_MultipleSelectSearch, {
                    "modal-title": "Pengecualian Kota Asal Terpilih",
                    "option-name": "kota",
                    onFocus: _ctx.fetchCity,
                    onFilter: _ctx.filterCity,
                    options: _ctx.cityExcludeOptions,
                    modelValue: _ctx.form.originCitiesExclude,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.form.originCitiesExclude = $event)),
                    keyName: "name",
                    keyValue: "value",
                    placeholder: "Pilih kota",
                    isLoading: _ctx.isLoadingCity,
                    "able-to-delete-in-modal": ""
                  }, null, 8, ["onFocus", "onFilter", "options", "modelValue", "isLoading"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_26, [
        _createVNode(_component_DataWrapper, {
          label: "Kota Tujuan",
          asterisk: true
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_27, [
              _createVNode(_component_MultipleSelectSearch, {
                "modal-title": "Kota Tujuan Terpilih",
                "option-name": "kota",
                onFocus: _ctx.fetchDestination,
                onFilter: _ctx.filterDestinationCity,
                options: _ctx.cityDestOptions,
                modelValue: _ctx.form.destinationCities,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.form.destinationCities = $event)),
                keyName: "name",
                keyValue: "value",
                placeholder: "Pilih kota",
                isLoading: _ctx.isLoadingCity,
                onChange: _ctx.onChangeDestinationCity,
                "able-to-delete-in-modal": ""
              }, null, 8, ["onFocus", "onFilter", "options", "modelValue", "isLoading", "onChange"])
            ])
          ]),
          _: 1
        }),
        (_ctx.isChooseAllCityDestination)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 0,
              label: "Pengecualian Kota Tujuan",
              optional: ""
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_28, [
                  _createVNode(_component_MultipleSelectSearch, {
                    "modal-title": "Pengecualian Kota Tujuan Terpilih",
                    "option-name": "kota",
                    onFocus: _ctx.fetchDestination,
                    onFilter: _ctx.filterDestinationCity,
                    options: _ctx.cityExcludeOptions,
                    modelValue: _ctx.form.destinationCitiesExclude,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.form.destinationCitiesExclude = $event)),
                    keyName: "name",
                    keyValue: "value",
                    placeholder: "Pilih kota",
                    isLoading: _ctx.isLoadingCity,
                    "able-to-delete-in-modal": ""
                  }, null, 8, ["onFocus", "onFilter", "options", "modelValue", "isLoading"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_29, [
        _createVNode(_component_DataWrapper, {
          label: "Tanggal mulai konfigurasi",
          asterisk: true
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_30, [
              _createVNode(_component_DatePicker, {
                modelValue: _ctx.form.startDate,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.form.startDate = $event)),
                minDate: new Date(new Date().setDate(new Date().getDate() + 1)),
                class: "my-2",
                disabled: _ctx.isFormTypeEdit
              }, null, 8, ["modelValue", "minDate", "disabled"]),
              _withDirectives(_createVNode("div", _hoisted_31, " Tanggal mulai tidak boleh lebih dari tanggal akhir ", 512), [
                [_vShow, _ctx.invalidStartDate]
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_DataWrapper, {
          label: "Tanggal selesai konfigurasi",
          asterisk: true
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_32, [
              _createVNode(_component_DatePicker, {
                class: "my-2",
                modelValue: _ctx.form.endDate,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.form.endDate = $event)),
                minDate: _ctx.minimumDateForEndDate
              }, null, 8, ["modelValue", "minDate"]),
              _withDirectives(_createVNode("div", _hoisted_33, " Tanggal akhir tidak boleh kurang dari tanggal mulai ", 512), [
                [_vShow, _ctx.invalidEndDate]
              ])
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
})